<template>
    <div class="outer-box">
        <div class="m-portlet  m-portlet--head-sm left  m-b-0">
            <div class="m-portlet__head">
                <div class="m-portlet__head-caption">
                    <div class="m-portlet__head-title">
                        <h3 class="m-portlet__head-text">
                            筛选条件
                        </h3>
                    </div>
                </div>
            </div>
            <div class="m-portlet__body m-portlet__body--small-padding ">
                <el-form label-position="top">
                    <el-form-item label="学科">
                        <el-select v-model="list_filter.subject_id" placeholder="请选择学科" clearable @change="handleClassPackages()">
                            <el-option
                                    v-for="item in subjects"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="年级" >
                        <el-select v-model="list_filter.grade_id" clearable placeholder="请选择年级"
                                   @change="handleClassPackages()">
                            <el-option
                                    v-for="item in grades"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="学期" >
                        <el-select v-model="list_filter.semesterType_id" clearable placeholder="请选择学期"
                                   @change="handleClassPackages()">
                            <el-option
                                    v-for="item in semesterTypes"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="类型" >
                        <el-select v-model="list_filter.type" clearable placeholder="请选择类型"
                                   @change="handleClassPackages()">
                            <el-option
                                    v-for="item in types"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="状态" >
                        <el-select v-model="list_filter.status" clearable placeholder="请选择状态"
                                   @change="handleClassPackages()">
                            <el-option
                                    v-for="item in status_arr"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="" >
                        <el-button size="mini" @click="handleStoreClassPackage()">创建</el-button>
                    </el-form-item>

                </el-form>
            </div>
        </div>
        <div class="m-portlet right m-b-0">
            <div class="m-portlet__body" :style="{'height':clientHeight-96-61.59+'px'}" v-loading="loading">
                <el-table v-if="!loading"
                          :data="orderClassPackages"
                          style="width: 100%"
                          :height="clientHeight-96-61.59-2.2-2-13-20"
                          size="middle">
                    <el-table-column prop="id" label="编号" min-width="10%"></el-table-column>
                    <el-table-column prop="name" label="套餐名" min-width="20%"> </el-table-column>
                    <el-table-column prop="type_name" label="类型" min-width="15%"> </el-table-column>
                    <el-table-column prop="status_name" label="状态" min-width="15%" ></el-table-column>
                    <el-table-column label="操作" min-width="40%">
                        <template slot-scope="scope">
                            <el-button @click="handleUpdateClassPackage(scope.row.id)">详情</el-button>
                            <el-dropdown trigger="click" size="medium">
                                <el-button>添加班级</el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item @click.native="handleStoreNormal(scope.row.id)">普通</el-dropdown-item>
                                    <el-dropdown-item @click.native="handleStoreSpecial(scope.row.id)">特殊</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                            <el-dropdown trigger="click" size="medium">
                                <el-button icon="el-icon-edit">修改状态</el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item @click.native="handleChangeClassPackage(scope.row.id,'creating')">创建中</el-dropdown-item>
                                    <el-dropdown-item @click.native="handleChangeClassPackage(scope.row.id,'active')">上架中</el-dropdown-item>
                                    <el-dropdown-item @click.native="handleChangeClassPackage(scope.row.id,'cancel')">已下架</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <div class="m-portlet__foot">
                <!--分页-->
                <div class="text-center">
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="10"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="total">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: "Index",
        data() {
            return {
                path: '/classPackage/list',
                loading: true,
                isHeadTeacher:false,
                classPackages: [],
                total: 0,
                currentPage: 1,
                currentPageSize: 10,
                semesterTypes: [],
                subjects: [],
                grades: [],
                types: [
                    {
                        value: 'combo',
                        label: '套餐'
                    }, {
                        value: 'single',
                        label: '单课'
                    }
                   ],
                status_arr: [
                    {
                        value: 'creating',
                        label: '创建中'
                    }, {
                        value: 'active',
                        label: '上架中'
                    }, {
                        value: 'cancel',
                        label: '已下架'
                    }],
                list_filter:{
                    subject_id: '',
                    grade_id:'',
                    semesterType_id:'',
                    status:''
                },
                Dialog_CreateClassPackage:{
                    classPackage:{
                        name:'',
                        suitable_for_student:'',
                        remark:'',
                        class_features:'',
                        curriculum:'',
                        problemPresented:'',
                        solution:'',
                        headTeacher_name:'',
                        headTeacher_phone:'',
                        type:''
                    },
                    button_loading:false
                },
                Dialog_UpdateClassPackage:{
                    classPackage:{
                        name:'',
                        remark:'',
                        class_features:'',
                        curriculum:'',
                        problemPresented:'',
                        solution:'',
                        headTeacher_name:'',
                        headTeacher_phone:'',
                        type:'',
                        classPackageFeatures:[
                            {
                                id:'',
                                name:'',
                                photo_url:''
                            }
                        ],
                        classPackageDetails:[]
                    },
                    fileList: [],
                    button_loading:false
                },
                //课表
                //课表的内容
                V4Judge: false,
                dialog_ChooseClass_loading: true,
                classPackageDetails:[],
                modalData: {},
                gradesInfo: {},
                semesters: {},
                timeData: {},
                teachers: {},
                classes: [],
                class_student: {},
                currentUsers: {},
                class_types: {},
                type: '',
                start_date: '',
                crunkView: false,
                disableType: false,
                note: '',
                tempLength: 0,
                filter: {
                    semester_id: this.$store.state.config.nowSemester.id,
                    grade_id: [],
                    date:'',
                    section_id:this.$store.state.config.section.id,
                },
                cell: {
                    selectable: false,
                    rect: [0, 0, 0, 0],
                    subject_id: '',
                    teacher_id: '',
                    template_time_id: '',
                    template_time_semester_id: '',
                    draggable: false,
                },
                teacherCell: {
                    selectable: false,
                    rect: [0, 1, 0, 0],
                    subject_id: '',
                    teacher_id: '',
                    template_time_id: '',
                    template_time_semester_id: '',
                    draggable: false,
                },
                showStudent: false,
                pluralClasses: {
                    viewJudge: false,
                    index: 0,
                    classes: [],
                    height: 50 * window.devicePixelRatio,
                },
                //学期
                scroll: {
                    left: 0,
                    top: 0
                },

                //dialogs
                classrooms: {},
                dialog_CreateClass_Semester: {
                    loading: false,
                    button_loading: false,
                    cartTableDialogVisible: false,
                    course: {},
                    courses: {},
                    search_loading: false,
                    classForm: {
                        name: '',
                        type: '',
                        classroom_id: '',
                        note: '',
                        subject_id: 0,
                        teacher_id: 0,
                        template_time_id: '',
                        template_time_semester_id: 0,
                        semester_id: 0,
                        class_type_id: 0,
                        grade_id: 0,
                        period: 0,
                        unit_period_price: 0,
                        start_date: '',
                        nightClass: false,
                        unit_classHour: 1,
                    }
                },
                timeTable: {
                    V4titleW: 100 * window.devicePixelRatio,
                    V4titleH: 50 * window.devicePixelRatio,
                    V4leftTimeW: 120 * window.devicePixelRatio,
                    V4rectW: 100 * window.devicePixelRatio,
                    V4rectH: 50 * window.devicePixelRatio,
                    V4ratio: window.devicePixelRatio,
                    V4divi: 2,
                },
            }
        },
        props: {},
        components: {},
        created() {
            this.handleCreate();
            this.handleInit();
            this.handleClassPackages();
        },
        beforeDestroy(){
            this.$wApi.removeListen(this.path)
        },
        computed: {
            powers(){
                return this.$store.state.config.powers;
            },
            orderClassPackages: function () {
                return this._.values(this.classPackages);
            },
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
        },
        methods: {
            handleCreate() {
                this.$wApi.addListen(this.path, this.handleData)
            },
            handleData(event, data) {
                switch (event) {
                    case 'subscribe':
                        break;
                    case 'list':
                        if (Object.keys(data.classPackages).length > 0) {
                            this.classPackages = data.classPackages;
                        } else {
                            this.classPackages = new Object();
                        }
                        this.total = data.total;
                        this.loading = false;
                        break;
                    case 'init':
                        this.subjects = data.subjects;
                        this.grades = data.grades;
                        this.semesterTypes = data.semesterTypes;
                        break;
                    case 'store_classPackage':
                        if(Object.keys(this.classPackages).length < 10){
                            this.$set(this.classPackages,data.classPackage.id,data.classPackage)
                        }
                        this.total++;
                        this.Dialog_CreateClassPackage.button_loading=false;
                        this.$Win.closeModal();
                        this.$message({
                            message: '添加成功',
                            type: 'success'
                        });
                        break;
                    case 'store_classPackage_error':
                        this.Dialog_CreateClassPackage.button_loading=false;
                        break;
                    case 'get_classPackage':
                        this.Dialog_UpdateClassPackage.classPackage = data.classPackage;
                        if (Object.keys(data.classPackage.classPackageFeatures).length == 0) {
                            this.Dialog_UpdateClassPackage.classPackage.classPackageFeatures = new Object();
                        }
                        break;
                    case 'update_classPackage':
                        this.$set(this.classPackages,data.classPackage.id,data.classPackage)
                        this.Dialog_UpdateClassPackage.button_loading=false;
                        this.$Win.closeModal();
                        this.$message({
                            message: '修改成功',
                            type: 'success'
                        });
                        break;
                    case 'update_classPackage_error':
                        this.Dialog_UpdateClassPackage.button_loading=false;
                        break;
                    case 'change_classPackage_status':
                        this.$set(this.classPackages,data.classPackage.id,data.classPackage)
                        this.$message({
                            message: '修改成功',
                            type: 'success'
                        });
                        break;
                    case 'give_class_to_classPackage':
                        Object.keys(this.classPackageDetails).forEach((item, index) => {
                            if (index === data.sortBy) {
                                this.classPackageDetails[index][0].name = data.class_name;
                                this.classPackageDetails[index][0].class_package_detail_id = data.classPackageDetail_id;
                            }
                        });
                        break;
                    case 'remove_class_from_classPackage':
                        Object.keys(this.classPackageDetails).forEach((item, index) => {
                            if (index === data.sortBy) {
                                this.classPackageDetails[index][0].name = '';
                                this.classPackageDetails[index][0].class_package_detail_id = '';
                            }
                        });
                        this.Dialog_UpdateClassPackage.classPackage.classPackageDetails.forEach((item,index) => {
                            if(item.id==data.classPackage_detail_id){
                                this.Dialog_UpdateClassPackage.classPackage.classPackageDetails.splice(index, 1);
                            }
                        });
                        break;
                    case 'get_classrooms':
                        this.classrooms = data.classrooms;
                        this.dialog_ChooseClass_loading = false;
                        break;
                    case 'showTable':
                        this.timeData = data.timeData;
                        this.subjects = data.subjects;
                        this.teachers = data.teachers;
                        this.classes = data.classes;
                        this.classrooms = data.classrooms;
                        this.class_student = data.class_student;
                        this.class_types = data.class_types;
                        this.semesters = data.semesters;
                        this.start_date = data.start_date;
                        this.tempLength = data.tempLength;
                        this.filter.section_id = data.section_id;
                        this.V4Judge = true;
                        this.loading = false;
                        this.dialog_ChooseClass_loading = false;
                        break;
                    case 'get_classPackage_detail_to_timeTable':
                        this.classPackageDetails=data.classPackageDetails
                        break;
                    case 'get_course':
                        if (data.type === 'create') {
                            this.dialog_CreateClass_Semester.courses = data.courses;
                            if (this.dialog_CreateClass_Semester.classForm.subject_id === 24) {
                                this.dialog_CreateClass_Semester.classForm.name = '晚托';
                                this.dialog_CreateClass_Semester.classForm.period = data.course_count;
                            } else {
                                this.dialog_CreateClass_Semester.course = data.course;
                                if (data.course) {
                                    this.dialog_CreateClass_Semester.classForm.period = data.course.period;
                                }
                                this.dialog_CreateClass_Semester.classForm.name = this.grades[this.dialog_CreateClass_Semester.classForm.grade_id].name +
                                    this.subjects[this.cell.subject_id].name;
                            }
                        }
                        break;
                    case 'search_classroom':
                        this.classrooms = data.classrooms;
                        this.dialog_CreateClass_Semester.search_loading = false;
                        break;
                    case 'store_class':
                        this.$message({
                            message: '创建成功',
                            type: 'success'
                        });
                        if (!this.classes[this.cell.teacher_id]) {
                            this.$set(this.classes, this.cell.teacher_id, []);
                        }
                        this.$set(this.classes[this.cell.teacher_id], this.cell.template_time_id, [data.createInfo]);
                        this.dialog_CreateClass_Semester.button_loading = false;
                        this.dialog_CreateClass_Semester.cartTableDialogVisible = false;
                        break;
                    case 'add_classPackage_features':
                        this.$set(this.Dialog_UpdateClassPackage.classPackage.classPackageFeatures,data.class_package_feature.id,data.class_package_feature);
                        break;
                    case 'delete_classPackage_features':
                        this.$delete(this.Dialog_UpdateClassPackage.classPackage.classPackageFeatures,data.class_package_features_id);
                        break;
                }
            },
            handleInit(){
                this.$wApi.send(this.path, 'init', {});
            },
            handleClassPackages(currentPage=1) {
                if (currentPage===1){
                    this.currentPage=1
                }
                this.$wApi.send(this.path, 'list', {
                    'currentPage': currentPage,
                    'currentPageSize': this.currentPageSize,
                    'filter': this.list_filter,
                });
            },
            handleSizeChange(val) {
                this.currentPageSize = val;
                this.loading = true;
                this.handleClassPackages(this.currentPage)
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.loading = true;
                this.handleClassPackages(this.currentPage)
            },
            handleStoreClassPackage(){
                this.$Win.openModal('Dialog_CreateClassPackage', 800, 400, '创建');
            },
            handleUpdateClassPackage(classPackage_id){
                this.$Win.openModal('Dialog_UpdateClassPackage', 800, 550, '修改',{'classPackage_id':classPackage_id});
            },
            handleChangeClassPackage(classPackage_id,status){
                this.$confirm('确定修改状态?', '提示', {
                    StartReturn: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$wApi.send(this.path, 'change_classPackage_status', {
                        'classPackage_id': classPackage_id,
                        'status': status,
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });

            },
            handleStoreNormal(classPackage_id){
                this.$Win.openModal('Dialog_ChooseClassPackageDetail', 1000, 900, '选择课程', {
                    'grade_id': '',
                    'studentPeriod_id': 0,
                    'semester_id': this.$store.state.config.nowSemester.id,
                    'classPackage_id':classPackage_id
                },true)
            },
            handleStoreSpecial(classPackage_id){
                this.$Win.openModal('Dialog_ChooseSpecialClassPackageDetail', 1000, 900, '选择课程', {
                    'grade_id=': '',
                    'studentPeriod_id': 0,
                    'semester_id': this.$store.state.config.nowSemester.id,
                    'classPackage_id':classPackage_id
                }, true);
            }
        }
    }
</script>

<style scoped lang="scss">
    .left {
        float: left;
        width: 300px;
    }

    .right {
        margin-left: 305px;
    }
</style>
